import ArrowButton, {ArrowButtonType} from 'components/atoms/arrowButton';
import RectangleImageButton from 'components/atoms/rectangleImageButton';
import {useTheme} from 'contexts/ThemeContext';
import React from 'react';
import {Image, Text, TouchableOpacity, View} from 'react-native';
import strings from 'translations';
import styleSheet from './styles';

export interface ConferenceHeaderProps {
  title: string;
  isParticipantsHidden: boolean;
  isShowHideButtonShown: boolean;
  onDisconnectButtonPressed: () => void;
  onPressBackButton: () => void;
  onPressShowHideParticipants: () => void;
}

const ConferenceHeader = (props: ConferenceHeaderProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  const ShowHideParticipantsButton = (
    <TouchableOpacity
      style={styles.hideParticipantsContainer}
      onPress={props.onPressShowHideParticipants}>
      <Image
        style={styles.hideParticipantsImage}
        source={
          props.isParticipantsHidden
            ? theme.images.symbolShow
            : theme.images.symbolHide
        }
      />
      <Text style={styles.hideParticipantsText}>
        {props.isParticipantsHidden
          ? strings.conferenceScreen.showParticipants
          : strings.conferenceScreen.hideParticipants}
      </Text>
    </TouchableOpacity>
  );

  return (
    <View style={styles.container}>
      <View style={styles.leftPart}>
        {theme.isWebSize && (
          <View style={styles.arrowContainer}>
            <ArrowButton
              isLeft={true}
              type={ArrowButtonType.default}
              onPress={props.onPressBackButton}
            />
          </View>
        )}
        <Text style={styles.title}>{props.title}</Text>
        {!theme.isWebSize && (
          <RectangleImageButton
            image={theme.images.disconnect}
            backgroundColor={theme.colors.red}
            onPress={props.onDisconnectButtonPressed}
          />
        )}
        {props.isShowHideButtonShown &&
          theme.isWebSize &&
          ShowHideParticipantsButton}
      </View>
    </View>
  );
};

export default ConferenceHeader;
